import axios from 'axios';
import config from '../config/api';

// Actualización de URL base para integración con backend
const API_URL = config.endpoints.caracteristicas;
const CREATE_URL = `${config.endpoints.caracteristicas}/crear`;

export const getCaracteristicas = (page, pageSize) => {
	if (page) {
		const params = new URLSearchParams();
		params.append('page', page);
		if (pageSize) params.append('pageSize', pageSize);
		return axios.get(`${API_URL}?${params.toString()}`);
	}
	return axios.get(API_URL);
};
export const getCaracteristicaById = (id) => axios.get(`${API_URL}/id/${id}`);
export const createCaracteristica = (data) => axios.post(CREATE_URL, data);
export const updateCaracteristica = (id, data) => axios.put(`${API_URL}/actualizar/${id}`, data);
export const deleteCaracteristica = (id) => axios.delete(`${API_URL}/eliminar/${id}`);